import {
  serializable,
  alias,
  primitive,
  custom,
  list,
  object,
} from "serializr";
import { AdminTypeEnum } from "../../enums/AdminType.enum";
import { AdminFeature } from "../AdminFeature/adminFeature.model";
import { DoctorFeature } from "../DoctorFeature/doctorFeature.model";

export class Admin {
  @serializable(alias("id", primitive()))
  id?: number;

  @serializable(alias("admin_id", primitive()))
  adminId?: number;

  @serializable(alias("approval_required", primitive()))
  approvalRequired?: boolean;

  @serializable(alias("company_name", primitive()))
  companyName?: string;

  @serializable(alias("add_signature_to_report", primitive()))
  addSignatureToReport?: boolean = true;

  @serializable(alias("email_notification", primitive()))
  emailNotification?: boolean = true;

  @serializable(alias("telegram_notification", primitive()))
  telegramNotification?: boolean = true;

  @serializable(alias("is_new_app", primitive()))
  isNewApp?: boolean = false;

  @serializable(alias("email", primitive()))
  email?: string;

  @serializable(alias("admin_type", primitive()))
  adminType?: AdminTypeEnum;

  @serializable(alias("address", primitive()))
  address?: string;

  @serializable(alias("state_of_registration", primitive()))
  stateOfRegistration?: string;

  @serializable(alias("specialisation", primitive()))
  specialisation?: string;

  @serializable(alias("medical_council_registration_number", primitive()))
  medicalCouncilRegistrationNumber?: string;

  @serializable(alias("password", primitive()))
  password?: string;

  @serializable(alias("name", primitive()))
  name?: string;

  @serializable(alias("first_name", primitive()))
  firstName?: string;

  @serializable(alias("last_name", primitive()))
  lastName?: string;

  @serializable(alias("mobile_number", primitive()))
  mobileNumber?: string;

  @serializable(alias("admin_signature_url", primitive()))
  adminSignatureUrl?: string;

  @serializable(alias("doctor_signature_url", primitive()))
  doctorSignatureUrl?: string;

  @serializable(alias("admin_features", list(object(AdminFeature))))
  adminFeatures?: AdminFeature[] = [];

  @serializable(alias("doctor_features", list(object(DoctorFeature))))
  doctorFeatures?: DoctorFeature[] = [];

  @serializable(
    alias(
      "doctor_signature",
      custom(
        (file) => file,
        (json) => {}
      )
    )
  )
  doctorSignature?: File;

  getFullName() {
    return this.firstName + " " + this.lastName;
  }
}
